import React from "react";
import { ThemeBasedColorHeader } from "src/shared/modules/profile/theme/themeCheacker";
import { Order } from "src/shared/types";

interface Props {
    order: Order | null;
    remaining: number;
}

export default function PaymentDetailsCard({ order, remaining }: Props) {
    if (!order) return null;

    // New interface: financial fields live in orders[0]
    const transaction = order.orders?.[0];
    const orderAmount = Number(transaction?.orderAmount ?? 0);   // sub-total
    const discount = Number(transaction?.discount ?? 0);
    const finalAmount = Number(transaction?.finalAmount ?? 0);

    // paymentMethod from first paymentHistory entry
    const paymentMethod = order.paymentHistory?.[0]?.paymentMethod ?? "-";

    const calOfFinalAmount = order.paymentHistory
        .filter((p) => p.paymentSource === "RETURN")
        .reduce(
            (acc, p) =>
                acc +
                Math.abs(
                    Number(p.receivedAmount ?? 0)
                ) + Math.abs(Number(p.adjustAmount ?? 0) || 0),
            0
        );

    return (
        <div className="bg-white rounded shadow">
            <div className={`${ThemeBasedColorHeader()} text-white p-2 rounded-t`}>
                Payment Details
            </div>

            <div className="p-2 text-sm space-y-1">
                <div className="flex justify-between">
                    <span>Sub Total</span>
                    <span>{orderAmount.toFixed(2)}</span>
                </div>

                <div className="flex justify-between">
                    <span>Discount</span>
                    <span>{discount.toFixed(2)}</span>
                </div>

                <div className="flex justify-between font-medium">
                    <span>Order Amount</span>
                    <span>{finalAmount.toFixed(2)}</span>
                </div>

                <div className="flex justify-between border-t border-dashed border-gray-400">
                    <span>Prev Return Amount (-)</span>
                    <span>{calOfFinalAmount.toFixed(2)}</span>
                </div>

                <div className="flex justify-between font-medium">
                    <span>Final Amount</span>
                    <span>{(finalAmount - calOfFinalAmount).toFixed(2)}</span>
                </div>

                <div className="flex justify-between font-semibold  border-t border-dashed border-gray-400">
                    <span>Remaining</span>
                    <span className={remaining > 0 ? "text-red-500" : "text-green-600"}>
                        {remaining.toFixed(2)}
                    </span>
                </div>

                <div className="flex justify-between">
                    <span>Payment Type</span>
                    <span>{paymentMethod}</span>
                </div>
            </div>
        </div>
    );
}